// @flow
import { styled } from 'mz-ui-kit'

export const Container = styled<{
  $focused?: boolean,
}>('div', ({ $focused, $palette }) => ({
  boxSizing: 'border-box',
  userSelect: 'none',
  position: 'relative',
  cursor: 'pointer',
  padding: '10px',
  ...(!$focused
    ? {}
    : {
        outline: 0,
        backgroundColor: `${$palette('gray').lighten(8)}`,
        zIndex: 10,
      }),
  ':active': {
    backgroundColor: `${$palette('primary')} !important`,
    color: `${$palette('white')}`,
  },
  ':hover': {
    backgroundColor: `${$palette('gray').lighten(8)}`,
  },
}))
